import React, { useState } from 'react';
import { 
  Box, 
  Button, 
  Typography, 
  Paper, 
  Alert,
  CircularProgress 
} from '@mui/material';
import { PlayArrow } from '@mui/icons-material';
import { MigrationUtils } from '../utils/migrationUtils';

const MigrationRunner: React.FC = () => {
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState<{ success: boolean; message: string } | null>(null);

  const handleRunMigration = async () => {
    setRunning(true);
    setResult(null);
    
    try {
      const result = await MigrationUtils.runAllMigrations();
      setResult({
        success: true,
        message: 'Migration completed successfully! Shared watchlists have been updated.'
      });
    } catch (error: any) {
      console.error('Migration error:', error);
      setResult({
        success: false,
        message: `Migration failed: ${error.message}`
      });
    } finally {
      setRunning(false);
    }
  };

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Database Migration for Shared Watchlists
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        This migration updates existing shared watchlists to add the 'isShared' field 
        required for the new sharing system. This only needs to be run once.
      </Typography>
      
      <Box sx={{ mt: 2 }}>
        <Button
          variant="contained"
          onClick={handleRunMigration}
          disabled={running}
          startIcon={running ? <CircularProgress size={20} /> : <PlayArrow />}
        >
          {running ? 'Running Migration...' : 'Run Migration'}
        </Button>
      </Box>
      
      {result && (
        <Alert severity={result.success ? 'success' : 'error'} sx={{ mt: 2 }}>
          {result.message}
        </Alert>
      )}
    </Paper>
  );
};

export default MigrationRunner;